export const HEADING_STYLES = {
  baseStyle: {
    fontWeight: "300",
    color: "brand.deep_sea",
  },
  sizes: {
    h1: {
      fontSize: "44px",
      lineHeight: "44px",
    },
    h2: {
      fontSize: "32px",
      lineHeight: "32px",
    },
    h3: {
      fontSize: "24px",
      lineHeight: "24px",
    },
    h4: {
      fontSize: "22px",
      lineHeight: "22px",
    },
    h5: {
      fontSize: "18px",
      lineHeight: "18px",
    },
    h6: {
      fontSize: "18px",
      lineHeight: "18px",
    },
  },
};
